export const throttle = function (fn, gap = 1000) {
  let lastTime = 0
  return function (...args) {
    const now = new Date().getTime()
    if (now - lastTime > gap) {
      lastTime = now
      fn.apply(this, args)
    }
  }
}

export const debounce = function (fn, wait = 1000) {
  let timer = null
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
      timer = null
    } else {
      fn.apply(this, args)
    }
    timer = setTimeout(function () {
      fn.apply(this, args)
    }, wait)
  }
}

export const format = function (date, fmt) {
  const o = {
    'M+': date.getMonth() + 1, // 月
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? o[k]
          : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export function timeRender (time) {
  const t = Math.round(new Date(time.replace(/-/g, '/')).getTime() / 1000)
  const now = Math.round(new Date().getTime() / 1000)
  const today = new Date(new Date().setHours(0, 0, 0, 0)) / 1000
  const diffTime = now - t

  if (diffTime < 60) {
    return diffTime <= 0 ? '刚刚' : diffTime + '秒前'
  } else if (diffTime < 60 * 60) {
    return Math.round(diffTime / 60) + '分钟前'
  } else if (t > today) {
    return Math.round(diffTime / 60 / 60) + '小时前'
  } else if (t > today - 60 * 60 * 24) {
    return '昨天' + format(new Date(t * 1000), 'hh:mm')
  } else if (t > today - 60 * 60 * 24 * 2) {
    return '前天' + format(new Date(t * 1000), 'hh:mm')
  } else {
    return format(new Date(t * 1000), 'yyyy-MM-dd hh:mm:ss')
  }
}

export const isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
  !window.MSStream

export const isInIframe = window.self !== window.top

/**
 * Fisher-Yates shuffle
 */
export const shuffle = (arr = []) => {
  const newArr = [...arr]
  const n = arr.length
  for (let i = 0; i < n; i += 1) {
    const rand = Math.floor(Math.random() * n);
    [newArr[i], newArr[rand]] = [newArr[rand], newArr[i]]
  }
  return newArr
}

export const thirdMode = window.__CONFIG__.VUE_APP_THIRD_PARTY_MODE

/**
 * 加密圖片有分成去掉`_n`的大圖與沒去掉`_n`的小圖, 兩張圖片會同時存在
 * 由前端判斷哪張圖片是因為這為顯示的邏輯
 * ex:
 * e8d6c02f-ea5b-46e9-ae77-46e604750569_n -> 小圖
 * e8d6c02f-ea5b-46e9-ae77-46e604750569 -> 大圖
 */
export const useEncryptBigImage = (url = '') => {
  return url.replace('_n', '')
}

export function getUUID () {
  let uuid = window.sessionStorage.getItem('uuid')

  if (uuid == null) {
    uuid = Math.random().toString(36).substring(2)
    window.sessionStorage.setItem('uuid', uuid)
  }

  return uuid
}



// WEBPACK FOOTER //
// ./src/utils/index.js